import BaseService from './base.service'
import { toast } from '@/common/util'
import baseApi from './base.api'

import type { InscreverUsuarios } from '@/types/types'

export const formationService = {
  ...baseApi,
  resource: 'formacao',

  async bookmark(formationId: string, remove?: boolean) {
    return formationService.post([formationId, !remove ? 'bookmark' : 'unbookmark'].join('/'))
  },

  async unbookmark(formationId: string) {
    return await formationService.post([formationId, 'unbookmark'].join('/'))
  },

  async setReactionFormation(params: { id: string, reacao?: string }) {
    return await formationService.post(`SetReaction`, params)
  },

  getDetails(id: string, ignoreFilterSection: boolean = false) {
    return formationService.get(`Detalhes/${id}`, {
      params: { ignoreFilterSection }
    })
  },

  /**
   * Inscreve o usuário em uma trilha
   * @param id - id da trilha
   * @param journeyId - opcional, para trilhas que fazem parte de uma jornada
   * @returns 
   */
  enroll(id: string, journeyId?: string) {
    return formationService.post([id, 'Subscribe'].join('/'), {
      jornadaId: journeyId || null
    })
  },

  unenroll(id: string) {
    return formationService.post([id, 'UnSubscribe'].join('/'))
  },

  coverUpload(id: string, file, orientation: 'horizontal' | 'vertical') {
    const type = orientation === 'horizontal' ? 'CardHorizontal' : 'CardVertical'

    const formData = new FormData()
    formData.append('arquivo', file)

    return formationService.post(`${id}/fileUpload/${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

class FormacaoService extends BaseService {
  constructor() {
    super({ resource: 'formacao' })
  }

  /**
   * Inscreve o usuário em uma formação
   * @param formationId
   */
  subscribe(formationId: string) {
    return this.plantarApi.post([this.resource, formationId, 'Subscribe'].join('/'))
  }

  /**
   * Desinscreve o usuário em uma formação
   * @param formationId
   */
  unsubscribe(formationId: string) {
    return this.plantarApi.post([this.resource, formationId, 'UnSubscribe'].join('/'))
  }

  async fileUpload(id: string, file) {
    return await this.plantarApi.post(`${this.resource}/${id}/fileUpload`, {
      arquivo: file,
      formacaoId: id
    }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async getBonds(formacaoId: string) {
    return this.plantarApi.get(`${this.resource}/vinculos/${formacaoId}`)
  }

  async getSubscriptions(formacaoId: string) {
    return this.plantarApi.get(`${this.resource}/inscricoes/${formacaoId}`)
  }

  async sendSubscriptions(data: InscreverUsuarios, inscrever?: boolean) {
    return this.plantarApi.post(`${this.resource}/inscreverusuarios/${inscrever}`, data)
  }

  async getDetails(formationId: string, ignoreFilterSection: boolean = false) {
    try {
      return this.plantarApi.get(`${this.resource}/Detalhes/${formationId}`, {
        params: { ignoreFilterSection }
      })

    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0]})
    }
  }
}

const formacaoService = new FormacaoService()

export default formacaoService
